import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("cp_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Auto-attach ?lang= for non-French sessions on GET requests
    const stored = localStorage.getItem("cp_lang");
    const lang = stored && stored.startsWith("en") ? "en" : null;
    if (lang && (config.method || "get").toLowerCase() === "get") {
        config.params = { ...(config.params || {}), lang };
    }
    return config;
});

export default api;
